import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAddRealEstate, TAddRealEstateResponse } from 'shared/repositories/cian-dobro/v1/add-real-estate';
import { markSubmitted } from 'shared/slices/formSlice';
import { ERegion } from 'shared/types/form';
import { IThunkApi, TApplicationState } from 'shared/types/redux';
import { trackFormSending } from 'shared/utils/analytics/tracking';

function getLocation(region: ERegion, location: string) {
  if (region === ERegion.Moscow || region === ERegion.MoscowRegion) {
    return region;
  }

  return location;
}

function scrollToFirstError(invalidFields: string[]) {
  const ys: number[] = [];
  for (const field of invalidFields) {
    const dataName = `DobroFormContainer-${field}`;
    const el = document.querySelector<HTMLElement>(`[data-name=${dataName}`);
    // istanbul ignore else
    if (el) {
      ys.push(el.offsetTop);
    }
  }

  // istanbul ignore else
  if (ys.length > 0) {
    const top = Math.min(...ys) - 28;

    // setTimeout добавлять стабильности внутри ФТ
    setTimeout(() => {
      window.scrollTo({
        top,
        left: 0,
        behavior: 'smooth',
      });
    }, 100);
  }
}

export const submitForm = createAsyncThunk<boolean, undefined, IThunkApi>('submitForm', async (_, api) => {
  api.dispatch(markSubmitted());

  const state: TApplicationState = api.getState();

  if (state.form.errors.hasErrors) {
    scrollToFirstError(state.form.errors.invalidFields);

    return false;
  }

  const form = state.form.data;

  // oxlint-disable-next-line no-console
  console.log(form);

  // istanbul ignore next
  if (form.guestsCount === null || form.objectType === null || form.priceType === null || form.moscow === null) {
    throw new Error('validation error');
  }

  trackFormSending();

  const res: TAddRealEstateResponse = await fetchAddRealEstate({
    httpApi: api.extra.httpApi,
    parameters: {
      additionalPhone: form.additionalPhone,
      location: getLocation(form.moscow, form.location),
      address: form.address,
      area: form.area === null ? undefined : form.area,
      availablePeriod: form.availablePeriod,
      floor: form.floor === null ? undefined : form.floor,
      guestsCount: form.guestsCount,
      bedsCount: form.bedsCount === null ? undefined : form.bedsCount,
      bedsDescription: form.bedsDescription,
      name: form.name,
      priceType: form.priceType,
      priceDescription: form.priceDescription,
      availableFor: form.availableFor,
      readyAccommodate: form.readyAccommodate,
      facilities: form.facilities,
      objectType: form.objectType,
      offerSigned: form.offerSigned,
      otherWishes: form.otherWishes,
      phone: form.phone,
      roomsCount: form.roomsCount === null ? undefined : form.roomsCount,
      telegram: form.telegram,
      email: form.email,
    },
  });

  if (res.statusCode !== 200) {
    throw new Error('submit error');
  }

  return true;
});
